import React from 'react';
import { Icons } from './Icons';

export const LegalModal = ({ title, content, onClose }: { title: string, content: React.ReactNode, onClose: () => void }) => (
  <div className="fixed inset-0 z-[100] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4">
    <div className="bg-white rounded-2xl w-full max-w-2xl max-h-[80vh] flex flex-col shadow-2xl animate-slide-up">
      <div className="p-6 border-b border-gray-100 flex justify-between items-center">
        <h3 className="text-xl font-serif font-bold text-ink">{title}</h3>
        <button onClick={onClose} className="text-gray-400 hover:text-ink"><Icons.X /></button>
      </div>
      <div className="p-8 overflow-y-auto text-sm text-gray-600 space-y-4 leading-relaxed">
        {content}
      </div>
    </div>
  </div>
);
